class Scroller extends HTMLElement {
  constructor() {
    super();

    // Make an array from the elements within `.scroller-inner`
    this.inner = this.querySelector('.scroller__inner');
    this.content = Array.from(this.inner.children);
  }

  connectedCallback() {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.addAnimation();
    }
  }

  disconnectedCallback() {}

  addAnimation() {
    // add data-animated="true" to every `.scroller` on the page
    this.setAttribute('data-animated', true);

    // For each item in the array, clone it
    // add aria-hidden to it
    // add it into the `.scroller-inner`
    this.content.forEach((item) => {
      const duplicatedItem = item.cloneNode(true);
      duplicatedItem.setAttribute('aria-hidden', true);
      this.inner.appendChild(duplicatedItem);
    });
  }
}

customElements.define('x-scroller', Scroller);
